<template>
  <v-dialog light  v-model="showForm" persistent max-width="600px">
    <v-form ref="form" v-model="isValid" :lazy-validation="lazy">
      <v-card>
        <v-card-title>
          <span class="headline">Warranty details</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  :rules="isRequired"
                  v-model="warranty.product"
                  label="Product*"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="warranty.seller"
                  :rules="isRequired"
                  label="Seller*"
                  hint="Name or website of acquisition"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="warranty.orderNumber" label="Order No" hint="Order number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                   <v-text-field
                      :rules="isDate"
                      v-model="warranty.buyDate"
                      hint="Expected date format: YYYY-MM-DD"
                      label="Acquisition date*"
                    ></v-text-field>

              
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="warranty.warrantyMonths"
                  :rules="isRequired"
                  label="Warranty period in months*"
                  hint="Number of months covered by warranty"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  name="input-7-4"
                  label="Expiration date"
                  v-model="expirationDate"
                  readonly
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea name="input-7-4" label="Details if needed." v-model="warranty.details"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
         
          <v-btn v-if="id>0" color="red darken-1" text @click="deleteW">Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Close</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>


 <v-dialog
      v-model="confirmDialog"
      max-width="350"
      persistent
    >
      <v-card>
        <v-card-title class="headline">Delete this one?</v-card-title>

      
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color=" darken-1"
            
            @click="confirmDialog = false"
          >
            No
          </v-btn>

          <v-btn
            color=" darken-1"
            text
            @click="deleteFromDb"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-dialog>
</template>

<script>

let apiUrl = process.env.VUE_APP_API_URL
apiUrl= "http://localhost:5000"
import Vue from 'vue'


export default {
  name: "WarrantyForm",
  computed: {
    expirationDate() {
      if (
        this.warranty &&
        this.warranty.buyDate &&
        this.warranty.warrantyMonths
      ) {
        let dt = new Date(this.warranty.buyDate);
        dt.setMonth(dt.getMonth() + parseInt( this.warranty.warrantyMonths));
        return dt.toISOString().split("T")[0];
      }
    }
  },
  props: {
    showForm: Boolean,
    
    id:{
      type:Number,
      default:0
    }
  },
  watch: { 
      	id: async function(newVal, oldVal) { // watch it
          console.log('Prop changed: ', newVal, ' | was: ', oldVal)
          if (newVal > 0){
          // this.showForm = false;
          const resp = await Vue.axios.get(`${apiUrl}/api/warranties/${this.id}`);
          this.warranty = resp.data;
          this.warranty.buyDate =new Date( this.warranty.buyDate.split("T")[0]).toISOString().split("T")[0];
          // this.showForm = true;
          }
        }
      },
  data() {
    return {
      confirmDialog:false,
      lazy: true,
      isValid: null,
      isRequired: [v => !!v || "This value is required"],
      isDate:[
          v => !!v || "This value is required" ,
           v=> {
               console.log('Parsing date: ', Date.parse(v) > 0);
               return Date.parse(v) > 0 || "Invalid date, expected: YYYY-MM-DD"}],
      warranty: {
        buyDate: new Date().toISOString().split("T")[0],
        warrantyMonths: 24,
        product: null,
        seller: null,
        details: null
      }
    };
  },
  methods: {
    async saveToDb(){
      var url =`${apiUrl}/api/warranties`;
      if (this.id > 0) url +=`/${this.id}`;
      var result;
      if (this.id>0)
       result = await Vue.axios.put(url, this.warranty);
      else
       result = await Vue.axios.post(url, this.warranty);

      this.resetWarranty();
        this.$emit("closeForm", true);
    },
    save() {
      if (this.$refs.form.validate()) {
        console.log("Saving ....");
        console.dir(this.warranty);
        this.saveToDb();
        // this.resetWarranty();
        // this.$emit("closeForm", true);
      }
    },
    close() {
      this.resetWarranty();
      this.$emit("closeForm", true);
      console.log("Saving ....");
    },
    resetWarranty() {
      this.$refs.form.resetValidation();

      this.warranty = {
        warrantyMonths: 24
      };
      this.warranty.buyDate = new Date().toISOString().split("T")[0];
    },
     async deleteW(){
       this.confirmDialog =true;
    },
    async deleteFromDb(){
      var url =`${apiUrl}/api/warranties/${this.id}`;
      await Vue.axios.delete(url);

      this.resetWarranty();
      this.$emit("closeForm", true);

    },
  },
  mounted() {console.log("Dialog mounted");}
};
</script>